// @flow
import React, { type Node } from 'react';

import { mergeClassNames } from 'utils/functions';

type RowProps = {
    /** will be appended to the classes */
    className: string,
    /** gutters on/off */
    gutters: bool,
    /** what will be rendered inside the row */
    children: Node,
}


export const Row = React.forwardRef((props: RowProps, ref) => {
    let {
        gutters = true,
        className = '',
        children,
        ...domProps
    } = props;

    className = mergeClassNames('row', !gutters ? 'no-gutters' : '', className);

    return <div ref={ref} className={className} {...domProps}>{children}</div>;
});

export default Row;
